import { useState, useEffect } from "react";

function Section({ tab, setTab, textContent }) {

  const [arrayfeatures, setArrayFeatures] = useState([]);
  const [arrayReviwews, setArrayReviews] = useState([]);

  useEffect(() => {
  setArrayFeatures(textContent?.home?.customProgram?.features || []);
  setArrayReviews(textContent?.home?.testimonials?.reviews || []);
  }, [textContent?.home?.customProgram?.features]);

  return (
    <section
      className={`tab-content ${tab === 0 ? "active" : ""}`}
      active
      id="tab-home"
    >
  
      <div className="section-content">
        <div className="section-text">
          <h1>{textContent?.home?.welcomeSection?.title}</h1>
          <br />
          <h2>{textContent?.home?.welcomeSection?.heading}</h2>
          <p>
            {textContent?.home?.welcomeSection?.description}
          </p>
          <button className="cta-button" onClick={() => setTab(4)}>
            {textContent?.home?.welcomeSection?.cta}
          </button>
        </div>
      </div>

      <div className="custom-program">
        <h2>{textContent?.home?.customProgram?.title}</h2>
        <p>
          <strong>{textContent?.home?.customProgram?.cta}</strong>
        </p>
        <div className="div0">
          <ul className="service-list">
            {arrayfeatures.map((service, index) => (
              index < 4 && (<li key={index} className="service-item">
                <h4>{service}</h4>
              </li>
              )
            ))}
          </ul>
          <ul className="service-list">
            {arrayfeatures.map((service, index) => (
              index >= 4 && (<li key={index} className="service-item">
                <h4>{service}</h4>
              </li>
              )
            ))}
          </ul>
        </div>
      </div>

      <center className="home-images">
        <img src="images/home/0.webp" alt="home0" />
        <img src="images/home/1.webp" alt="home1" />
        <img src="images/home/2.webp" alt="home2" />
      </center>

      <div className="testimonials">
        <section class="testimonials-section">
          <div class="container">
            <div class="testimonials-intro">
              <h2>{textContent?.home?.testimonials?.heading}</h2>
              <p>
                {textContent?.home?.testimonials?.description}
              </p>
            </div>

            <div class="testimonials-cards">
              {arrayReviwews.map((review, index) => (
                <div class={`card card-${index + 1}`} key={index}>
                <div class="stars">{review.rating}</div>
                <p class="quote">
                  "{review.text}"
                </p>
                <p class="author">- {review.author}</p>
              </div>
              ))}
            </div>
          </div>
        </section>
      </div>
    </section>
  );
}

export default Section;
